import React from 'react';
import { CloseOutlined } from '@landr/maestro';
import { t } from '@lingui/macro';
import { ActionButton } from 'components/ActionButton';
import { ActionButtonProps } from 'components/ActionButton/ActionButton';
import { Sample } from 'types/generated/graphql';
import useDeleteCollectionSampleButton from 'components/DeleteCollectionSampleButton/useDeleteCollectionSampleButton';

export interface DeleteCollectionSampleButtonProps
    extends Omit<ActionButtonProps, 'icon' | 'label' | 'onClick'> {
    samples: Sample[];
    onClick?: () => void;
    label?: string;
}

const DeleteCollectionSampleButton: React.FC<
    DeleteCollectionSampleButtonProps
> = ({ samples, ...props }) => {
    const { handleClick } = useDeleteCollectionSampleButton({ samples });

    return (
        <ActionButton
            icon={CloseOutlined}
            authOnly
            aria-label={t`Remove from collection`}
            label={t`Remove from collection`}
            onClick={handleClick}
            isDisabled={!samples?.length}
            {...props}
        />
    );
};

export default DeleteCollectionSampleButton;
